import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-screens',
  templateUrl: './screens.component.html',
  styleUrls: ['./screens.component.css']
})
export class ScreensComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
